/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ImageAddImageUploadResponse } from "./ImageAddImageUploadResponse";

export type ImageAddImageUploadResponseApiRespoonse = {
  data?: ImageAddImageUploadResponse;
  status?: ImageAddImageUploadResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace ImageAddImageUploadResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
